module.exports = __webpack_public_path__ + "img/ventadirectalasamericas.784ee150.jpg";